export const MAX_TOASTS_COUNT_AT_TIME = 1;
export const DEFAULT_TOAST_AUTOCLOSE_TIME = 3000;
